

import { useState } from "react";
import { Card } from "@material-ui/core";
import { Box, Button, Divider, Grid, MenuItem, TextField, Typography } from "@mui/material";
import api from "../../../../../services/api";
import MessageSuccess from "../../../../../messages/messageSuccess";
import MessageError from "../../../../../messages/messageError";
import { useDispatch, useSelector } from "react-redux";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";
import ButtonLeft from "../../../../../utils/buttonLeft";
import FazerObservacoes from "../../../../components/fazerObservacoes.";
import TextoFormatado from "../../../../../utils/textoFormatado";
import AddImagens from "./addImagens";
import DeleteAnalise from "./deleteAnalise";


export default function AnaliseDissolucao({ avaliacaoId, ficha, analises, handleClose }) {
    // const { avaliacaoId } = useParams()
    const dispatch = useDispatch()
    const [avaliacao, setAvaliacao] = useState({})
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [open, setOpen] = useState(false);
    const [obs, setObs] = useState('')
    const user = useSelector(state => state.account.user);

    function HandleChange(e) {
        setAvaliacao((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }

    const submitAvaliacao = async () => {

        setOpen(true)
        setMessageSuccess('')
        setMessageError('')
        // console.log(avaliacao)

        const formData = new FormData();
        formData.append('userId', user?._id);
        formData.append('avaliacaoAnaliticaId', avaliacaoId);
        formData.append('observacao', obs);
        formData.append('padrao', avaliacao?.padrao ?? '');
        formData.append('amostra', avaliacao?.amostra ?? '');
        formData.append('resultado', avaliacao?.resultado ?? '');
        if (avaliacao?.imagens) {
            for (let imagem of avaliacao?.imagens) { formData.append('imagens', imagem ?? ''); }
        }

        await api.patch('/avalicao-analitica/teste/dissolucao', formData)
            .then(res => {
                setMessageSuccess(res.data.msg)
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Análise inserida com sucesso' },
                });
                handleClose();

            }).catch(err => {
                setMessageError(err.response.data.message)
            }).finally(() => setOpen(false))
    }

    // console.log(analises)
    const renderField = (label, value) => (
        <Grid item xs={12} sm={6}>
            <Box>
                <Typography variant="caption" color="text.secondary">
                    {label}
                </Typography>
                <Typography variant="body1">
                    {value || 'Não informado'}
                </Typography>
            </Box>
        </Grid>
    );

    return (
        <Card style={{ padding: 15, marginTop: 20, minWidth: 700 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}


            <HeaderGestorConfigs title={'Analise de Dissolução'} />
            {ficha ?
                analises.map((analise, index) => (
                    <div key={analise._id}>
                    <DeleteAnalise url={'/avalicao-analitica/delete/teste/dissolucao'} id={avaliacaoId} index={index}/>
                        <Typography p={1} variant="subtitle1">Análise número:{index + 1}</Typography>
                        <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                            <Grid container spacing={2}>
                                {renderField('Padrão', analise.padrao)}
                                {renderField('Amostra', analise.amostra)}
                                {renderField('Resultado', analise.resultado)}
                            </Grid>
                        </Box>
                        <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Observação:</strong>  <TextoFormatado texto={analise?.observacao ?? ''} /> </Typography>
                        </Box>

                        <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                            <AddImagens avaliacao={analise} />
                        </Box>
                        <Divider />
                    </div>
                ))
                :
                <>
                    <Grid container >
                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Padrão"
                                fullWidth
                                size="small"
                                name="padrao"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.padrao}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Amostra"
                                fullWidth
                                size="small"
                                name="amostra"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.amostra}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Resultado"
                                select
                                fullWidth
                                size="small"
                                name="resultado"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.resultado || ''}
                            >
                                <MenuItem value={'Aprovado'} name="resultado">
                                    Aprovado
                                </MenuItem>
                                <MenuItem value={'Reprovado'} name="resultado">
                                    Reprovado
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>

                    <FazerObservacoes setObs={setObs} obs={obs} titulo={''} />

                    <AddImagens
                        addImagens={true}
                        avaliacao={avaliacao}
                        setAvaliacao={setAvaliacao}
                    />

                    <ButtonLeft
                        title={'Salvar'}
                        funcao={submitAvaliacao}
                        load={open}
                    >
                        <Button onClick={handleClose} color="warning" size="small" style={{ marginTop: 20, marginRight: 10 }}>Cancelar</Button>
                    </ButtonLeft>
                </>
            }
        </Card>
    )
}